
// Heights that do not change.
export const COMMON_HEIGHTS = {
  BORDER: -0.5,
  BACKGROUND: -0.5,
  BACKGROUND_TEXTURE: -0.1,
  WATER: -0.05,
  BELOW_ROAD_BACKGROUND_TEXTURE: 0.004,
  ROAD_BACKGROUND: 0.008,
  LOWER_EDGES: 0.009,
  // Deprecated buildings - when they were placed under the road
  DEPRECATED_BUILDINGS: 0.0,
  EDGES: 0.01,
  ABOVE_ROAD_BACKGROUND_TEXTURE: 0.015,
  ZERO_HEIGHT_BUILDINGS: 0.015,
  TREE_AREA_EDIT: 0.017,
  LOT_FILL_HOVER: 0.02,
  DECORATION: 0.025,
  LIGHT: 0.028,
  // The plane version of these
  FENCE: 0.04,
  WALL: 0.07,
  WALL_TOWER: 0.08,
  BORDER_EDGE: 0.1,
}
